import React from 'react'
const Button = React.lazy(() => import('@mui/material/Button'))
const Container = React.lazy(() => import('@mui/material/Container'))
const Stack = React.lazy(() => import('@mui/material/Stack'))
const Typography = React.lazy(() => import('@mui/material/Typography'))

const ErrorIcon = React.lazy(() => import('@mui/icons-material/ErrorOutline'))

const ErrorPage = ({
  error,
  icon: Icon = ErrorIcon,
  empty = false,
  retry,
  children,
  buttonLabel = 'Retry',
}) => {
  return (
    <Container>
      <Stack spacing={2} alignItems='center'>
        <Icon color={empty ? 'disabled' : 'error'} style={{ fontSize: 200 }} />
        <Typography variant='h3' align='center'>
          {error?.status}
        </Typography>
        <Typography variant='h4' align='center'>
          {error?.statusText}
        </Typography>
        <Typography paragraph align='center'>
          {children || error?.message}
        </Typography>
        {retry && (
          <Button color='primary' variant='contained' onClick={retry}>
            {buttonLabel}
          </Button>
        )}
      </Stack>
    </Container>
  )
}

export default ErrorPage
